import { convertFromRaw, EditorState, RawDraftContentState } from 'draft-js';
import { isObjectLike } from 'lodash';
import { CellData } from '../../../../../../common/table/TableTypes';
import { parseCellContentString } from '../../../../../../common/table/utils/tableCellContentStringUtils';
import getContentInlineStyle from '../../../../../components/editor/customRichUtils/contentState/getContentInlineStyle';
import { STYLE_COMMANDS } from '../../../../../components/editor/richText/richTextConstants';

const IGNORED_STYLES = [
    STYLE_COMMANDS.LARGE_HEADING,
    STYLE_COMMANDS.HEADING,
    STYLE_COMMANDS.SMALL_TEXT,
    STYLE_COMMANDS.CODE,
    STYLE_COMMANDS.BLOCKQUOTE,
];
const isActionableStyle = (style: string): boolean => !IGNORED_STYLES.includes(style);

/**
 * Returns the Draft styles that apply uniformly across all text content in the cell.
 */
export const getDraftCellLevelTextStyles = (draftContent: RawDraftContentState): string[] => {
    const content = convertFromRaw(draftContent);

    return Array.from(getContentInlineStyle(content) || []).filter(isActionableStyle);
};

/**
 * Returns whether a cell has the specified inline style, checking both cell-level
 * style metadata and Draft content when present.
 */
export const doesTableCellDataHaveInlineStyles = (cellData: CellData, inlineStyle: string): boolean => {
    if (cellData.textStyle?.includes(inlineStyle)) return true;
    if (!cellData.value) return false;

    const content = cellData.draftContent || parseCellContentString(cellData.value);
    if (!isObjectLike(content)) return false;

    const editorState = EditorState.createWithContent(convertFromRaw(content as RawDraftContentState));
    return editorState.getCurrentInlineStyle().includes(inlineStyle);
};
